export default __webpack_public_path__ + "static/media/00.342dcc80.jpg";